'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.match");

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var axios = require('axios');

var dataExp = /window\._sharedData\s?=\s?({.+);<\/script>/;

var RequestError = require('./model/RequestError');

var Media = require('./model/Media');

var User = require('./model/User');

var Image = require('./model/Image');

var urlParser = require('./urlParser');

var parse = function parse(string) {
  var json = null;

  try {
    var dataString = string.match(dataExp)[1];
    json = JSON.parse(dataString);
  } catch (err) {
    throw err;
  }

  return json;
};

var normalizeMedia = function normalizeMedia(arr) {
  var list = [];

  var _iterator = _createForOfIteratorHelper(arr),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var origin = _step.value;
      var item = new Image(origin.node);
      list.push(item);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return new Media(list);
};

exports.tag = function (tag, callback) {
  var url = 'https://www.instagram.com/explore/tags/' + encodeURIComponent(urlParser.tag(tag)) + '?__a=1';
  return axios.get(url).then(function (res) {
    var json = res.data;
    var result = {
      media: normalizeMedia(json.graphql.hashtag.edge_hashtag_to_media.edges)
    };
    callback(null, result);
  })["catch"](function (err) {
    callback(new RequestError(err));
  });
};

exports.user = function (user, callback) {
  var url = 'https://www.instagram.com/' + urlParser.user(user);
  return axios.get(url).then(function (res) {
    var json = parse(res.data);
    var result = {
      user: new User(json.entry_data.ProfilePage[0].graphql.user),
      media: normalizeMedia(json.entry_data.ProfilePage[0].graphql.user.edge_owner_to_timeline_media.edges)
    };
    callback(null, result);
  })["catch"](function (err) {
    callback(new RequestError(err));
  });
}; // exports Models


exports.Media = Media;
exports.User = User;
exports.urlParser = urlParser;